import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__utils_index_js_57e9e83f__ from "../../utils/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__ from "../../variants/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__CdnIcon_index_js_9849600d__ from "../CdnIcon/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__IconA_variants_js_297fda4e__ from "./IconA.variants.js";
function IconA({ className, iconName, href, ...props }) {
    const { buttonSlot, wrapperSlot, iconSlot, tapSpaceSlot } = (0, __WEBPACK_EXTERNAL_MODULE__IconA_variants_js_297fda4e__.iconAVariants)(props);
    const classes = (0, __WEBPACK_EXTERNAL_MODULE__utils_index_js_57e9e83f__.cn)(className, wrapperSlot());
    const iconSize = (0, __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__.getIconSize)(props.size);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("a", {
        href: href,
        ...(0, __WEBPACK_EXTERNAL_MODULE__utils_index_js_57e9e83f__.cleanProps)(props, [
            'type',
            'shadow'
        ]),
        className: buttonSlot(),
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: tapSpaceSlot()
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: classes,
                "data-testid": "icon-a-wrapper",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__CdnIcon_index_js_9849600d__.CdnIcon, {
                    className: iconSlot(),
                    iconName: iconName,
                    size: iconSize
                })
            })
        ]
    });
}
export { IconA };
